import { useExlyFeedbacksStore } from "../../store/useExlyFeedbacksStore";

export const useFeedbackSettingsModal = () => {
  const setOfferingFeedbackSettingsModalOpen = useExlyFeedbacksStore(
    (state) => state.setOfferingFeedbackSettingsModalOpen
  );
  const offeringFeedbackSettingsModalOpen = useExlyFeedbacksStore(
    (state) => state.offeringFeedbackSettingsModalOpen
  );
  const openOfferingFeedbackSettingsModal = () => {
    setOfferingFeedbackSettingsModalOpen(true);
  };
  const closeOfferingFeedbackSettingsModal = () => {
    setOfferingFeedbackSettingsModalOpen(false);
  };
  return {
    offeringFeedbackSettingsModalOpen,
    openOfferingFeedbackSettingsModal,
    closeOfferingFeedbackSettingsModal,
  };
};
